<template>
	<inertia-head title="Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Insurance Information
					</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Please update your informaation for the insurance purpose
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<div class="row py-4">
			<div class="col-xl-9 m-auto">
				<div v-if="member.is_otp_confirm==1" class="block block-rounded shadow">
					<div class="block-header">
						PLEASE UPLOAD ONE VALID ID THAT SHOWS YOUR FULL NAME AND BIRTHDAY.
					</div>
					<div class="block-content block-content-full">
						<div v-if="member.is_docu_rejected==1" class="h5">Please reupload your document.</div>
						<div class="form-floating mb-4">
							<select v-model="form.id_type" id="id_type" name="id_type" class="form-control" placeholder="Please select your ID Type">
  								<option value="">Please select</option>
  								<option value="Drivers License">Drivers License</option>
  								<option value="SSS ID">SSS ID</option>
  								<option value="Passport">Passport</option>
  								<option value="National ID(Phylsys ID)">National ID(Phylsys ID)</option>
  								<option value="NSO Birth Cerfiticate">NSO Birth Cerfiticate</option>
  							</select>
							<label class="form-label">Please select your ID Type</label>
							<div v-if="form.errors.id_type && form.id_type==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.id_type }}
							</div>
						</div>
						<div class="form-floating mb-4">
							<input @change="uploadFile" type="file" id="id_type_document" class="form-control" accept="image/*" placeholder="Please select your ID Type Document" />
							<label class="form-label">Please select your ID Type Document</label>
							<div v-if="form.errors.id_type_document && form.id_type_document==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.id_type_document }}
							</div>
							<div v-if="form.id_type_document!==''" class="mt-4">
								<label>ID Type Document Preview</label>
								<img :src="img_preview" class="shadow p-2 img-fluid" style="width: 100%;height: auto;"/>
							</div>
						</div>
					</div>
					<div class="block-footer pb-5 text-center">
						<button @click="uploadDocument" type="button" class="btn btn-success px-5">
							<span v-if="!form.processing"><i class="fa fa-upload me-1"></i>
								<span v-if="member.is_docu_rejected==0">Upload</span>
								<span v-else>Re-upload</span>
							</span>
							<span v-else>
								<div class="spinner-border spinner-border-sm text-dark" role="status" >
									<span class="sr-only mr-1">Please wait...</span>
								</div>
								<span class="mx-2">Please wait...</span>
							</span>
						</button>
						<div v-if="is_change=='yes'" class="mt-4">
							<inertia-link href="verification" class="text-info"><i class="fa fa-arrow-circle-right me-1"></i>Back to verification page</inertia-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { watch, ref, onMounted } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	props:{
		flash 				: Object,
		errors 				: Object,
		member 				: Object,
		api_response		: Object,
		is_change 			: String
	},
	layout: AuthLayout,
	setup(props) {

		const toast 		= createToaster();
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
		})


		
		const form = useForm({
						id_type 			: '',
						id_type_document 	: '',
						is_docu_reupload 	: props.member.is_docu_rejected==1 ? 1 : 0
					});

		const img_preview = ref(null);

		const uploadFile = (e) => {

			if (e.target.files.length > 0) {
				form.id_type_document 	= e.target.files[0]
				const preview 			= URL.createObjectURL(e.target.files[0]);
				img_preview.value 		= preview;
			} else {
				form.id_type_document 	= ''
				img_preview.value 		= null;
			}
		}


		const uploadDocument = ()=>{
			form.post("upload-document/"+props.member.member_uuid,{
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','member'],
				onSuccess:()=>{
					form.reset();
				},
				onError: (errors)=>{

				var fields = ['id_type','id_type_document'];
				//Check if error exist and focus the first field.
				for (var i = 0; i < fields.length; i++) {

					var found = false;

					for (const [key, value] of Object.entries(form)) {

						if(fields[i]==key){

							if(form.errors[key]){
								var  el = document.getElementById(key);

								el.focus();	

								found = true;

								break;
							}
						}
					}

					if(found==true){
						break;
					}
				}
			}
			})
		}

		watch(()=>props.api_response,(response)=>{
			
			if(response!=null)
			{
				if(response.result=="success")
				{
					toast.show("Document was successfully uploaded", { type: response.result});
				}else
				{
					toast.show("Failed to upload", { type: "error"});
				}
			}
		})

		return{
			toast,
			form,
			img_preview,
			uploadFile,
			uploadDocument,
		}

	},
}
</script>
